// extracted by mini-css-extract-plugin
export default {"column":"_3g6Bv","title":"Ztrk8","slider":"gRDgs","subtitle":"vi50k","link":"NwOsU","list":"QMxLK","singleList":"gVKgR","arrow":"_0b0Z-","skeleton-progress":"Y4EMs"};